
import { 
    AppEnum,
    FaBuilding,
    FaCalendar, 
    FaClock, 
    FaEnvelope, 
    FaHashtag, 
    FaTasks, 
    FaUserTag, 
    Header, 
    OptionHelper,
    PlanningEnums,
    RecordMap
} from "@/Shared";

import { UserModel, ContactModel, PropertyModel } from '@/Domains';

import { PlanningViewModel } from "./ViewModels";

export type SelectOption = {
    value: any,
    label: any
}

export class PlanningHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    get planningDate() {
        return {
            key: 'planningDate',
            icon: <FaCalendar />,
            label: 'Date',
            type: 'string',
            isSortable: true
        }
    }

    get startTime() {
        return {
            key: 'startTime',
            icon: <FaClock />,
            label: 'Heure début',
            type: 'string',
            isSortable: true
        }
    }

    get endTime() {
        return {
            key: 'endTime',
            icon: <FaClock />,
            label: 'Heure fin',
            type: 'string',
            isSortable: true
        }
    }

    get note() {
        return {
            key: 'note',
            icon: <FaEnvelope />,
            label: 'Note',
            type: 'string',
            isSortable: true
        }
    }

    get feedback() {
        return {
            key: 'feedback',
            icon: <FaUserTag />,
            label: 'Feedbacks',
            type: 'string',
            isSortable: true
        }
    }

    get remarks() {
        return {
            key: 'remarks',
            icon: <FaEnvelope />,
            label: 'Remarques',
            type: 'string',
            isSortable: true
        }
    }

    getContact(contactMap : RecordMap<ContactModel>) {
        return {
            key: 'contact',
            icon: <FaUserTag />,
            label: 'Prospect',
            type: 'string',
            isSortable: true,
        }
    }

    getProperty(propertyMap : RecordMap<PropertyModel>) {
        return {
            key: 'property',
            icon: <FaBuilding />,
            label: 'Bien',
            type: 'string',
            isSortable: true,
        }
    }

    getType(types: AppEnum[]) {
        return {
            key: 'type',
            icon: <FaTasks />,
            label: 'Type',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Type",
                options: OptionHelper.sortByLabel(types),
                case: 'sensitive'
            }
        }
    }

    getUser(agentlist: RecordMap<UserModel>) {
        return {
            key: 'agent',
            icon: <FaUserTag />,
            label: 'User',
            type: 'string',
            isSortable: true,
            filter: {
                label: "User",
                options: OptionHelper.userOptions(agentlist.toArray()),
                case: 'sensitive'
            }
        }
    }

    
    get createdAt() {
        return {
            key: 'createdAt',
            icon: <FaCalendar />,
            label: 'Date',
            type: 'string',
            isSortable: true
        }
    }

    static build(
        contactMap: RecordMap<ContactModel>,
        propertyMap: RecordMap<PropertyModel>,
        agentMap: RecordMap<UserModel>,
        viewEnums: PlanningEnums

    ): Record<keyof PlanningViewModel, Header<PlanningViewModel>> {

        const header = new PlanningHeader();

        return {
            id: header.id,
            planningDate : header.planningDate,
            startTime : header.startTime,
            endTime : header.endTime,
            note : header.note,
            feedback: header.feedback,
            remarks: header.remarks, 
            contact : header.getContact(contactMap),
            property : header.getProperty(propertyMap),
            agent : header.getUser(agentMap),
            typeLabel: header.getType(viewEnums.PlanningTypeEnum)


        } as Record<keyof PlanningViewModel, Header<PlanningViewModel>>
    }
}